export default __webpack_public_path__ + "static/media/Prayer_calender_Thumbnail for home page.8b7fa110.jpg";